<template>
<w-sliding-popup ref="slidingPopup" title="IP대역 선택" :type="type" width="600px" @open="onPopupOpen" @close="onPopupClose">
  <div slot="content" style="width: 100%; height:100%;">
    <w-ip-search-setting-table ref="ipRange" class="mr-b25" :type="type" :checked-data.sync="checkedData"></w-ip-search-setting-table>
  </div>
  <div slot="footer">
    <div>
      <el-button size="large" type="solid" @click="onSaveClick">저장</el-button>
      <el-button size="large" @click="onCancelClick">취소</el-button>
    </div>
  </div>
</w-sliding-popup>
</template>

<script>
import { isEmpty } from 'lodash';
import Base from '@/mixins/topologymap/base';
import WIpSearchSettingTable from '@/views/settings/operation/ScheduleSettings/NetworkScheduleSettings/components/table/IpSearchSettingTable';

export default {
  name: 'WIpRangeSelectPopup',
  components: {
    WIpSearchSettingTable,
  },
  mixins: [Base],
  props: {
    type: {
      type: String,
      default: 'setting',
    },
    checkedIp: {
      type: Array,
      default: () => ([]),
    },
  },
  data() {
    return {
      isEmpty,
      scheduleData: [],
      // checkedIpSearchRows: [],
      checkedData: [],
    };
  },
  watch: {
    checkedRows(val) {
      this.$emit('update:checkedIp', val);
    },
  },
  methods: {
    open(scheduleData, checkedIp) {
      this.scheduleData = scheduleData;
      this.checkedData = checkedIp;
      this.loadData();
      this.$refs.slidingPopup.open();
    },
    close() {
      this.initData();
      this.$refs.slidingPopup.close();
    },
    onPopupOpen() {
      this.loadData();
    },
    onPopupClose() {
      this.initData();
    },
    onSaveClick() {
      this.$emit('syncIp', this.checkedData);
      this.close();
    },
    onCancelClick() {
      this.close();
    },
    initData() {
      if (!isEmpty(this.$refs.ipRange)) {
        this.$refs.ipRange.init();
      }
    },
    loadData() {
      if (!isEmpty(this.$refs.ipRange)) {
        this.$refs.ipRange.loadData();
      }
    },
  },
};
</script>

<style lang="scss">
.map-property-popup {
  .el-tabs__content {
    padding-top: 10px !important;
    height: calc(100% - 40px);
  }
}
</style>



// WEBPACK FOOTER //
// src/views/settings/operation/ScheduleSettings/NetworkScheduleSettings/components/popup/IpRangeSelectPopup.vue